<template>
  <div class="layout-mosaic-content" id="identidade-visual-mosaico" data-search-anchor>
    <div class="title-layout-mosaic-wrapper">
      <h1 class="layout-mosaic-title-span">{{ layoutMosaicTitleSpan }}</h1>
      <h1 class="layout-mosaic-title">{{ layoutMosaicTitle }}</h1>
    </div>
    <div class="descriptiom-layout-mosaic-wrapper">      
      <p class="layout-mosaic-description">{{ layoutMosaicDescription1 }}</p>      
    </div>
    <div
      class="layout-mosaic-card-item1"
      :style="{ backgroundImage: `url(${layoutMosaicImageSrc})`}"
    ></div>
    <div
      class="layout-mosaic-card-item"
      :style="{ backgroundImage: `url(${layoutMosaicImageSrc1})`}"
    ></div>
    <div
      class="layout-mosaic-card-item"
      :style="{ backgroundImage: `url(${layoutMosaicImageSrc2})`}"
    ></div>
    <div
      class="layout-mosaic-card-item"
      :style="{ backgroundImage: `url(${layoutMosaicImageSrc3})`}"
    ></div>
    <div
      class="layout-mosaic-card-item"
      :style="{ backgroundImage: `url(${layoutMosaicImageSrc4})`}"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LayoutsMosaicSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutMosaicTitleSpan(): string {
    return this.getElementTitle(19, 0)
  }

  get layoutMosaicTitle(): string {
    return this.getElementText(19, 0)
  }

  get layoutMosaicDescription1(): string {
    return this.getElementText(19, 1)
  }

  get layoutMosaicImageSrc(): string {
    return this.getElementMedia(19, 2)
  }

  get layoutMosaicImageSrc1(): string {
    return this.getElementMedia(19, 3)
  }

  get layoutMosaicImageSrc2(): string {
    return this.getElementMedia(19, 4)
  }

  get layoutMosaicImageSrc3(): string {
    return this.getElementMedia(19, 5)
  }

  get layoutMosaicImageSrc4(): string {
    return this.getElementMedia(19, 6)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-mosaic-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-mosaic-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;
}

.layout-mosaic-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #b3b3b3;
}

.layout-mosaic-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-mosaic-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%; 
}

.layout-mosaic-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;
  margin-top: 0;
}

.layout-mosaic-card-item1,
.layout-mosaic-card-item {
  position: relative;   

  max-width: 1032px;
  width: 100%;
  height: 527px;

  background-repeat: no-repeat;
  background-size: contain;
}
.layout-mosaic-card-item1{
   margin-bottom: 1rem;
}
</style>
